import React, { useContext } from "react";
import { AuthContext } from "../../services/AuthContext";

import "./RadioHistoryMain.css";
import { useAlert } from "../../services/AlertProvider";
import usePlayerControls from "../../hooks/usePlayerControls";
import usePlayerUtils from "../../hooks/usePlayerUtils";


export default function RadioHistoryMain() {
    const {
        audioRef,
        currentTrack,
        nowPlaying,
        playbackState,
        audioTimeMs,
        setCurrentTimeSec,
        durationPercent,
        setManualTrack,
        setIsSeeking,
        setTimeShiftOffsetSec,
        timeShiftOffsetSec,
        parseDuration,
    } = usePlayerUtils();

    const {
        wrapChildClick,
    } = usePlayerControls({});

    const { isLoggedIn, setUserModalOpen } = useContext(AuthContext);

    const { showAlert } = useAlert();

    const isNext = (startedAt) => {
        if (playbackState !== "playing" || audioTimeMs <= 0 || startedAt === null || startedAt === "") { return false }

        const startedAtNext = startedAt
        const staredAtMs = new Date(startedAtNext).getTime();
        const isNext = staredAtMs > audioTimeMs + timeShiftOffsetSec * 1000;

        return isNext
    }

    const historySeek = (staredAt, duration, clickPercent = 0) => {
        const { maxTimeShiftSeconds, currentLiveTime, history } = nowPlaying || {};
        if (!staredAt || !duration || staredAt === "" || duration === "") return;

        const audio = audioRef.current;
        if (!audio || !maxTimeShiftSeconds || !currentLiveTime || !history?.length) return;

        if (playbackState === "stopped") {
            audio.play();
            showAlert("Click again to seek to this track");
            return;
        }

        if (isNext(staredAt)) {
            showAlert("You can't seek here yet!");
            return;
        }

        // if (!isLoggedIn) {
        //     setUserModalOpen(true);
        //     return;
        // }

        const staredAtMs = new Date(staredAt).getTime();

        const bufferStartMs = audioTimeMs - (maxTimeShiftSeconds - timeShiftOffsetSec) * 1000;
        const realCurrentTime = timeShiftOffsetSec + audio.currentTime;
        const realCurrentStartedAtMs = bufferStartMs + realCurrentTime * 1000;

        const targetStartedAtMs = currentTrack?.startedAt === staredAt
            ? staredAtMs + parseDuration(duration) * clickPercent * 1000
            : staredAtMs;

        if (targetStartedAtMs > realCurrentStartedAtMs) {
            audio.currentTime = realCurrentTime;
            setTimeShiftOffsetSec(0);
            return;
        }

        const percent = (targetStartedAtMs - bufferStartMs) / (maxTimeShiftSeconds * 1000);
        const desiredMs = realCurrentTime - maxTimeShiftSeconds + percent * maxTimeShiftSeconds;

        if (desiredMs <= 0) {
            showAlert("You can't play this song anymore!")
            return;
        }

        const newOffset = realCurrentTime - desiredMs;

        setTimeShiftOffsetSec(newOffset);

        audio.currentTime = desiredMs;
        setCurrentTimeSec(desiredMs);

        const currentSong = history.find(song => {
            const start = new Date(song.startedAt).getTime();
            return targetStartedAtMs >= start;
        });

        if (currentSong) {
            setManualTrack(currentSong);
            setIsSeeking(true);
        }
    };

    const handleTrackClick = (song) => {
        const audio = audioRef.current;
        const isCurrentTrack = startedAt === song.startedAt;
        const isActive = playbackState === "playing" || playbackState === "paused";

        if (isCurrentTrack && isActive && audio) {
            if (playbackState === "playing") {
                audio.pause();
            } else {
                audio.play();
            }
            return;
        }

        historySeek(song.startedAt, song.duration);
    };

    const startedAt = currentTrack?.startedAt;

    const { history } = nowPlaying || {};
    const songHistory = history || [];

    return (
        <div className="d-history-main">
            <div className="d-player-hystory">
                <div className="d-expanded-history-main">
                    <div className="d-expanded-history-title">
                        <div className="d-histoty-title-main">
                            <div>HISTORY</div>
                        </div>
                        <div className="d-histoty-title-second">
                            <div>PLAYED TRACKS</div>
                        </div>
                    </div>
                    <div className="d-expanded-history-contetnt">
                        <div className="d-inner-history-content">
                            <div className="d-contetnt-list">
                                <ul
                                    style={{ paddingTop: "20px", paddingBottom: "10px" }}
                                    className="d-scrollable-list"
                                >
                                    {songHistory.map((song, idx) => {
                                        const prevSong = songHistory[idx - 1];
                                        const isLastInPlaylist =
                                            !prevSong || song.playlistName !== prevSong.playlistName;

                                        return (
                                            <React.Fragment key={idx}>
                                                {isLastInPlaylist && song.playlistName && (
                                                    <li className="playlist-separator">
                                                        <span className="separator-label">{song.playlistName}</span>
                                                    </li>
                                                )}
                                                <li
                                                    className={
                                                        (playbackState === "playing" || playbackState === "paused") && startedAt === song.startedAt
                                                            ? "track-item active-track-item"
                                                            : "track-item"
                                                    }
                                                >
                                                    {(playbackState === "playing" || playbackState === "paused") &&
                                                        startedAt === song.startedAt && (
                                                            <>
                                                                <div className="d-list-song-end"></div>
                                                                <div
                                                                    className="d-list-song-filled"
                                                                    style={{
                                                                        width: `${durationPercent() * 100}%`,
                                                                        backgroundColor: playbackState === "playing"
                                                                            ? "rgb(179, 177, 177)"
                                                                            : "rgb(127, 127, 127)",
                                                                    }}
                                                                ></div>

                                                            </>
                                                        )}

                                                    <button
                                                        className="d-list-song-link d-contetnt-item"
                                                        onClick={(e) => {
                                                            wrapChildClick(() => { handleTrackClick(song) })();
                                                        }}
                                                    >
                                                        <div className="d-play-animation">
                                                            {startedAt === song.startedAt &&
                                                                (playbackState === "playing"
                                                                    ? <div class="eq">
                                                                        <span></span><span></span><span></span><span></span><span></span>
                                                                    </div>
                                                                    : playbackState === "paused"
                                                                        ? <div><i className="fas fa-pause"></i></div>
                                                                        : null
                                                                )}
                                                        </div>
                                                        <div className="d-contetnt-item-track">
                                                            <div className="d-contetnt-item-title" title={song.title}>{song.title}</div>
                                                            <div className="d-contetnt-item-artist" title={song.artist}>{song.artist}</div>
                                                        </div>

                                                        <div className="d-contetnt-item-play">
                                                            {isNext(song.startedAt)
                                                                ? (<div className="d-up-next">UP NEXT</div>)
                                                                : (
                                                                    <div className="d-contetnt-item-play-active">
                                                                        <div className="d-contetnt-item-play-duration">
                                                                            <div>{song.duration}</div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </button>
                                                </li>
                                            </React.Fragment>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};